export default "__VITE_ASSET__BWB6IcA9__"